// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a92f8520","732":"3d48720c"}[chunkId] + ".chunk.js";
};